export type Channel = "web" | "ait" | "ios" | "android";

const tossHosts = new Set(["hanjan-shieo.apps.tossmini.com", "hanjan-shieo.private-apps.tossmini.com"]);

export function resolveChannel(location: Pick<Location, "hostname" | "search"> | undefined, nativePlatform?: string, buildChannel?: string): Channel {
  if (buildChannel === "ait" || (location && tossHosts.has(location.hostname))) return "ait";
  if (nativePlatform === "ios" || nativePlatform === "android") return nativePlatform;
  // A query string is useful for local fixtures; public links cannot change storage or transport.
  if (location && ["localhost", "127.0.0.1"].includes(location.hostname)) {
    const requested = new URLSearchParams(location.search).get("channel");
    if (requested === "ait" || requested === "ios" || requested === "android") return requested;
  }
  return "web";
}

export const channel = resolveChannel(
  typeof location === "undefined" ? undefined : location,
  (globalThis as { Capacitor?: { getPlatform?: () => string } }).Capacitor?.getPlatform?.(),
  import.meta.env.VITE_CHANNEL,
);

export function channelApiUrl(path: string, target: Channel = channel): string {
  if (!path.startsWith("/api/v1/")) throw new Error("Unsupported API path");
  return target === "ait" ? `https://hanjanshieo.com${path}` : path;
}
